import Card from 'react-bootstrap/Card';
import { useVizStore } from '@/store';

export default function MapOptions() {
  const openDrawer = useVizStore((s) => s.openDrawer);

  return (
    <Card className="d-inline-block h-100">
      <Card.Body className="d-flex align-items-center justify-content-left gap-0 py-0">
        <i
          className="bi bi-gear-fill"
          style={{
            fontSize: '1.5rem',
            cursor: 'pointer',
            transition: 'transform 0.2s ease-in-out',
          }}
          onClick={() => openDrawer()}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'rotate(15deg)';
            e.currentTarget.style.color = 'var(--bs-primary)';
            const text = e.currentTarget.nextElementSibling as HTMLElement;
            if (text) {
              text.style.color = 'var(--bs-primary)';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'rotate(0deg)';
            e.currentTarget.style.color = '';
            const text = e.currentTarget.nextElementSibling as HTMLElement;
            if (text) {
              text.style.color = '';
            }
          }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              openDrawer();
            }
          }}
          aria-label="Open options drawer"
        />
        <span
          className="ms-2"
          onClick={() => openDrawer()}
          style={{
            fontSize: '1.5rem',
            cursor: 'pointer',
            transition: 'transform 0.2s ease-in-out',
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.color = 'var(--bs-primary)';
            const gear = e.currentTarget.previousElementSibling as HTMLElement;
            if (gear) {
              gear.style.transform = 'rotate(15deg)';
              gear.style.color = 'var(--bs-primary)';
            }
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.color = '';
            const gear = e.currentTarget.previousElementSibling as HTMLElement;
            if (gear) {
              gear.style.transform = 'rotate(0deg)';
              gear.style.color = '';
            }
          }}
        >
          Map Options
        </span>
      </Card.Body>
    </Card>
  );
}
